import React from "react";
import * as userAction from "../../actions/user-action";



export default class ChangePassword extends React.Component {
    constructor() {
        super();
        this.state = {
            errMsg: ""
        };
    }

    handleSubmit() {

        const password1 = this.refs.newPassword1.value;
        const password2 = this.refs.newPassword2.value;
        if (!(password1.length < 5 || password1.length > 16)) {
            if (password1 === password2) {
                if (this.props.pageProps.location.query.autoGen && this.props.pageProps.location.query.id) {
                    //write down the code here                    
                    userAction.updatePassword({ password: password1, userPic: null, userId: this.props.pageProps.location.query.id, autoGen: this.props.pageProps.location.query.autoGen });

                } else {
                    const errMsg = "missing token and id";
                    this.setState({ errMsg });
                }

            } else {
                const errMsg = "passwords don't match";
                this.setState({ errMsg });
            }
        } else {
            const errMsg = "password must be 5 to 15 characters";
            this.setState({ errMsg });
        }


    }
    componentDidMount() {
        this.refs.newPassword1.focus();
    }
    render() {
        //window.x = this.props;
        //console.log(this.props);
        return (
            <div className="smallholder">
                <table className="formTable">
                    <tbody>
                        <tr>
                            <td>
                                <input
                                    type="password"
                                    className="formControl inputBox"
                                    placeholder="New Password"
                                    ref="newPassword1"
                                    tabIndex="1"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p id="tipBox" >{this.state.errMsg}</p>
                                <input
                                    type="password"
                                    className="formControl inputBox"
                                    placeholder="Re-enter New Password"
                                    ref="newPassword2"
                                    tabIndex="2"
                                />

                            </td>
                        </tr>
                    </tbody>
                </table>
                <button
                    tabIndex="3"
                    className="btn btnOk btnRight"
                    onClick={this.handleSubmit.bind(this)}
                >
                    Submit
                </button>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/jsx/components/fragments/change-password.jsx